// extracted by mini-css-extract-plugin
module.exports = {"induceText":"CampaignLotteryDrawResultNothing_induceText___CfbW"};